import { Injectable, NgZone, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthStore } from '../store/auth.store';
import { SessionService } from './session.service';

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'wheel', 'scroll', 'touchstart'];

/** Frecuencia con la que se evalúa la inactividad acumulada. */
const CHECK_INTERVAL_MS = 30_000;

@Injectable({ providedIn: 'root' })
export class IdleService {
  private zone      = inject(NgZone);
  private authStore = inject(AuthStore);
  private session   = inject(SessionService);

  private readonly timeoutMs = environment.idleTimeoutMinutes * 60_000;
  private lastActivity = Date.now();
  private started = false;

  start(): void {
    if (this.started) return;
    this.started = true;

    // Fuera de la zona: `mousemove` dispararía detección de cambios continuamente.
    this.zone.runOutsideAngular(() => {
      ACTIVITY_EVENTS.forEach((event) =>
        document.addEventListener(event, this.registerActivity, { passive: true, capture: true }),
      );
      setInterval(() => this.check(), CHECK_INTERVAL_MS);
    });
  }

  /** Reinicia el contador tras autenticarse o restaurar la sesión. */
  reset(): void {
    this.lastActivity = Date.now();
  }

  private registerActivity = (): void => {
    this.lastActivity = Date.now();
  };

  private check(): void {
    if (!this.authStore.isAuthenticated()) return;
    if (Date.now() - this.lastActivity < this.timeoutMs) return;
    this.zone.run(() => this.session.end('inactivity'));
  }
}
